///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace - use fieldValidate attributes similar to Vue v-if
//
///////////////////////////////////////////////////////////////////////////////////////////////////
window.fieldValidate = window.fieldValidate || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
window.fieldValidate.offsetTop = null;
window.fieldValidate._debug = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    window.fieldValidate.init();
});


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
window.fieldValidate = {
    init: function () {
        this._debug = false;

        this._bindInvalidHandler();
        this._bindBrowserRevalidation();
        this._bindCustomValidators();

        // Create an observer instance to watch for new elements being added to the DOM.
        new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            this._bindInvalidHandler(node);
                        }
                    });
                }
            }
        }).observe(document.body, { childList: true, subtree: true });

        // NOTE: moved to fieldLib and extented
        // Prevent non-numeric values in input.numeric and input[type=number] fields
        // $(":input.numeric, :input[type=number]").keypress(function (e) {
        //     //if the letter is not digit then display error and don't type anything
        //     if (e.which != 8 && e.which != 0 && e.which != 13 && (e.which < 48 || e.which > 57)) {
        //         return false;
        //     }
        // });
    },

    /**
     * Should the given event result in revalidation of the field?
     *
     * @param event
     * @returns {boolean}
     * @private
     */
    _changeNecessitatesRevalidation(event) {
        if ($(event.target).is('.select2-hidden-accessible')) {
            return true; // Any change from a Select2 container changing its originating element's value will be considered a change the validator cares about.
        }

        const keysToIgnore = [
            17, // ctrl
            16, // shift
            18, // alt
            9, // tab
            38, // up
            40, // down
            37, // left
            39, // right
            91, // windows
        ];

        // Assuming this was a user event (programmatically triggered) when given an originalEvent.
        // If it was done by a user and we have a key pressed, filter out keys like shift, ctrl, alt, arrows, Windows.
        return event.originalEvent && (!event.which || !keysToIgnore.includes(event.which));
    },

    /**
     * Revalidate non-fieldValidate fields (HTML validation) when they change.
     *
     * @private
     */
    _bindBrowserRevalidation() {
        const _this = this;

        // Fields with fieldValidate will be taken care of by the custom validator binding.
        // We're selecting fields based on Bootstrap's field classes. We could use jQuery's ":input" or something like :radio,:checkbox,textarea,select,button,input.
        const fieldSelectors = [
            /*
             * <form class="fieldValidations">
             *     <input class="form-control" required>                              <!-- This field WILL be captured by this selector. -->
             *     <input class="form-control">                                       <!-- This field WILL be captured by this selector. -->
             *     <input class="form-control" fieldValidate="alphaNumeric" required> <!-- This field WILL NOT be captured by this selector. -->>
             * </form>
             * <form> <!-- This form will be ignored by this selector -->
             *     ...
             * </form>
             */
            'form.fieldValidations .form-control:not([fieldValidate])',

            /*
             * <form class="fieldValidations"> <!-- This form will be ignored by this selector -->>
             *     ...
             * </form>
             * <form>
             *     <input class="form-control" required>                              <!-- This field WILL be captured by this selector. -->
             *     <input class="form-control">                                       <!-- This field WILL be captured by this selector. -->
             *     <input class="form-control" fieldValidate="alphaNumeric" required> <!-- This field WILL NOT be captured by this selector. -->>
             * </form>
             */
            'form:not(.fieldValidations) .form-control:not([fieldValidate])',
            'form.fieldValidations select.select2-hidden-accessible:not([fieldValidate])', // Select2 widgets. Only if they don't have a fieldValidate attribute and they're in in forms with the fieldValidations class.
            'form.fieldValidations .form-check-input:not([fieldValidate])', // Checkboxes and radios. https://getbootstrap.com/docs/4.5/components/forms/#checkboxes-and-radios
        ];

        // `revalidate` is useful for situations where you want to trigger a change event on a field but you don't want to trigger validations.
        //  (for instance, if you're programmatically changing its value and you want calculations that run on-change to run, but you're not ready to show validation messages yet.)
        $(document).on('change keyup', fieldSelectors.join(','), function (event, {revalidate = null} = {}) {
            if (revalidate !== true && !_this._changeNecessitatesRevalidation(event)) {
                return;
            }

            _this._outputDebug(`Running validations for HTML validated field (${event.type})`, [$(this).attr('name') || $(this).attr('id') || '']);
            _this.removeOrnaments(this);
            if (!this.checkValidity()) {
                _this._setInvalidRule(this, 'browser');
            }
        });
    },

    /**
     * Bind fieldValidate validation handlers to fieldValidate elements.
     *
     * @private
     */
    _bindCustomValidators() {
        const _this = this;

        // `revalidate` is useful for situations where you want to trigger a change event on a field but you don't want to trigger validations.
        //  (for instance, if you're programmatically changing its value and you want calculations that run on-change to run, but you're not ready to show validation messages yet.)
        $(document).on('change keyup', '[fieldValidate]', function (event, {revalidate = false, initialRun = false} = {}) {
            if (revalidate || initialRun || _this._changeNecessitatesRevalidation(event)) {
                _this.runValidations($(this), {revalidate, initialRun}, event);
            }
        });

        $('[fieldValidate]').trigger('change', {initialRun: true});
    },

    /**
     * Run validations for the given field.
     * This will run HTML/Browser validations as well as fieldValidate custom validations.
     *
     * Example usage:
     * fieldValidate.runValidations($(':input:visible:first-of-type')); // A single field
     * fieldValidate.runValidations($('#my-form .tabs:first-of-type :input:visible')); // A list of fields
     * fieldValidate.runValidations($('#my-form .tabs:first-of-type')); // A fields container
     * fieldValidate.runValidations($('#my-lonely-field,#my-form,.special-fields')); // A mixture
     *
     * A field's rules are made up of method names, separated by a pipe (|) or an ampersand (&) and set via the fieldvalidate HTML attribute.
     *
     * Each rule can provide options after a colon (:). Each option is separated by a comma (,).
     *   These affect how the rule will be run (that is, they affect how this method runs).
     *
     * Validations are executed in order (the pipe and ampersands do not affect this).
     * For example:
     * fieldValidate="validationMethod2:no-instant,ax12|validationMethod99:debounce|validationMethod10"
     *
     * Options supported:
     *   - no-instant: Do not run this validation while the user is typing (aka "instant" validation).
     *   - always-run: Run this validation, even if the browser validation fails (this does not override the no-instant setting).
     *
     * @param {jQuery|*} fieldsOrContainers One or many form fields, one or many field containers, or a mixture.
     * @param {boolean} initialRun Is this the initial run of the rules? Some rules shouldn't be run while we're setting up all the bindings.
     * @param {Event} event The event, if any, that triggered the validation.
     * @returns {Promise<boolean>} Is *everything* valid?
     *
     * @private
     */
    runValidations(fieldsOrContainers, {initialRun = false} = {}, event = null) {
        if ($(fieldsOrContainers).length === 1 && !$(fieldsOrContainers).is(':input')) {
            // We treat containers the same way we treat a listing of fields.
            fieldsOrContainers = $(fieldsOrContainers).find(':input:visible');
        }

        if ($(fieldsOrContainers).length > 1) {
            // We were given a list of something. Recursively iterate through the items and report if all validations through all recursions passed.
            return Promise.all(
                $(fieldsOrContainers).toArray().map((fieldOrContainer) => this.runValidations(fieldOrContainer))
            ).then(validationResults => validationResults.every(Boolean));
        }

        // Now, we're down to the case where we're working with just one field to validate.

        const field = $(fieldsOrContainers);
        const rules = (field.attr('fieldValidate') || '').split(/[&|]/).filter(Boolean);

        this._outputDebug('Running validations for: ' + (field.attr('name') || field.attr('id') || ''), rules, field.toArray());

        this.resetValidation(field);

        // Only check HTML/browser validations if we're not doing an initialRun
        const isValidViaBrowser = !initialRun ? field[0].checkValidity() : true;
        if (!isValidViaBrowser) {
            this._setInvalidRule(field, 'browser');
        }

        return Promise.all(
            rules.map(async rule => {
                rule = this._parseRule(rule);

                if (!isValidViaBrowser && !rule.runValidationsOptions.includes('always-run')) {
                    // No need to run custom validations if we're currently failing the HTML/browser validations.
                    return;
                }

                if (event && event.type !== 'change' && rule.runValidationsOptions.includes('no-instant')) {
                    this._outputDebug('Instant validations are not on for this rule on this field.');
                    return;
                }

                // do not run validation if not shown
                if($(field).is(':hidden'))
                    return;

                const validationResult = await window.fieldValidate[rule.method](field, {initialRun});
                this._outputDebug(`\twindow.fieldValidate.${rule.method}`, validationResult);
                await rule.run(field, {initialRun});
            })
        ).then(() => {
            // Only run checkValidity if we're not doing an initialRun
            if (!initialRun) {
                field[0].checkValidity();
            }
        }).catch(e => {
            this._setMessage(field, 'An error occurred while validating this field', 'runValidations', true);
            throw e;
        });
    },

    /**
     * Check the validity of a given field, a set of fields, a container of fields or a mixture of these.
     *
     * @param fieldsOrContainers
     * @returns {jQuery|boolean}
     */
    checkValidity(fieldsOrContainers) {
        if ($(fieldsOrContainers).length === 1 && !$(fieldsOrContainers).is(':input')) {
            // We treat containers the same way we treat a listing of fields.
            fieldsOrContainers = $(fieldsOrContainers).find(':input:visible:not(:disabled)');
        }

        return $(fieldsOrContainers).length > 1
            // We were given a list of something. Recursively iterate through the items and report if all validations through all recursions passed.
            ? $(fieldsOrContainers).toArray().filter(fieldOrContainer => !this.checkValidity(fieldOrContainer)).length === 0 // No invalid fields found.
            : $(fieldsOrContainers)[0].checkValidity();
    },

    /**
     * Converts a rule definition into a structure we can work with.
     *
     * @param {string} rule
     * @returns {{runValidationsOptions: string[], method: string, object: string, run: function}}
     * @private
     */
    _parseRule(rule) {
        // Expected format: ruleMethod:option1,option2
        const [method, runValidationsOptions = ''] = rule.split(':');
        // Looking for this format: ruleObject.ruleMethod:option1,option2 (these rule objects will be under the fieldValidate namespace (e.g. fieldValidate.ruleObject.ruleMethod()))
        const [object, objectMethod] = method.split('.');

        const result = {
            object: objectMethod ? object : null, // If we don't have an object method, then we don't have an object (and object will just be set to the method to call on this object).
            method: objectMethod || method,
            runValidationsOptions: runValidationsOptions.split(',').filter(Boolean),
        };

        const run = async (...args) => {
            if (!result.object) {
                if (!fieldValidate.hasOwnProperty(result.method)) {
                    console.error(`\tfieldValidate.${result.method} - Not a validation method (${rule})`);
                    return;
                }

                const validationResult = await fieldValidate[result.method](...args);
                this._outputDebug(`\tfieldValidate.${result.method}`, validationResult);
                return;
            }

            if (!fieldValidate.hasOwnProperty(result.object)) {
                console.error(`\tfieldValidate.${result.object}.${result.method} - Not a validation method. Object does not exist. (${rule})`);
                return;
            } else if (!fieldValidate[result.object].hasOwnProperty(result.method)) {
                console.error(`\tfieldValidate.${result.object}.${result.method} - Not a validation method (${rule})`);
                return;
            }

            const validationResult = await fieldValidate[result.object][result.method](...args);
            this._outputDebug(`\tfieldValidate.${result.object}.${result.method}`, validationResult);
        };

        return {run, ...result};
    },

    /**
     * Focus on fields elements that are invalid at the time of submission
     *
     * @param {jQuery|*|null} parent
     *
     * @private
     */
    _bindInvalidHandler(parent = null) {
        // listen for 'invalid' events on all form inputs
        $(':input', parent).off('invalid.fieldValidate').on('invalid.fieldValidate', function (e) {
            // Prevent the popup error message
            e.preventDefault();

            const input = $(this);
            const invalidFields = $(this).closest('form').find(':invalid');
            const first = invalidFields.first();
            const firstVisible = invalidFields.filter(':input:visible').first();

            window.fieldValidate.applyOrnaments(input);

            // Add a customizable class and message for the section_validate fields
            if ($(this).hasClass('section_validate')) {
                $(this).siblings('.errorMsg').addClass('sectionErrorMsg');
            }

            // Add a customizable message for the attachment_file fields
            if ($(this).hasClass('attachment_file')) {
                const html = $('.btn[data-type="' + $(this).data('type')).html() || 'file';
                $(this).siblings('.errorMsg').html('Please select ' + abcsetup.indefiniteArticle(html) + ' ' + html);
            }

            if (input[0] === first[0]) {
                // Notify routes that we have at least one invalid field (add a fieldError callback to your route file to hook into this route-event).
                abcsetup.loadRouteJS('fieldError');
            }

            // Focus the first invalid field.
            if (input[0] === firstVisible[0]) {
                // height of the nav bar plus some padding
                var navbarHeight = $('nav.navbar').height() + 50;

                if (typeof window.fieldValidate.offsetTop !== "undefined") {
                    navbarHeight = navbarHeight + window.fieldValidate.offsetTop;
                }

                var elementOffset = input.offset().top - navbarHeight;
                var pageOffset = window.pageYOffset - navbarHeight;

                // don't scroll if the element is already in view
                if (elementOffset > pageOffset && elementOffset < pageOffset + window.innerHeight) {
                    return true;
                }

                // Note: avoid using animate, as it prevents the validation message displaying correctly
                if (elementOffset < 0) {
                    elementOffset = elementOffset * -1;
                }

                //console.log(elementOffset);
                const parentElem = input.closest('.form-div:visible') ?? $('html, body');
                parentElem.scrollTop(elementOffset);
                if (!($(input).hasClass("readonly"))) {
                    $(input).trigger('focus');
                }
            }
        });
    },

    toggleDebug(value) {
        this._debug = value === undefined ? !this._debug : !!value;
        console.log(`Field Validation debugging ${this._debug ? 'on' : 'off'}`);
    },

    _outputDebug(...args) {
        this._debug && console.log(...args);
    },

    /**
     * Set the validation message for the given field.
     * This method is meant to be called from outside of this class (to provide a namespace that allows us to prevent name collisions with rules within this class).
     *
     * @param {jQuery|*} field
     * @param {string} message
     * @param {string} tag
     * @param {boolean} triggerInvalid
     */
    setMessage(field, message, tag, triggerInvalid = false) {
        this._setMessage(field, message, `externally_set_${tag}`, triggerInvalid);
    },

    /**
     * Overwrite the current message only if the given tag was what set the current message (or there is no message right now).
     * This method is meant to be called from outside of this class (to provide a namespace that allows us to prevent name collisions with rules within this class).
     *
     * @param {jQuery|*} field
     * @param {string} message
     * @param {string} tag
     * @param {boolean} triggerInvalid
     * @returns {boolean} If the message was overwritten.
     */
    overwriteMessageFromSameTag(field, message, tag, triggerInvalid = false) {
        return this._overwriteMessageFromSameRule(field, message, `externally_set_${tag}`, triggerInvalid);
    },

    /**
     * Overwrite the current message only if the given rule was what set the current message (or there is no message right now).
     *
     * @param {jQuery|*} field
     * @param {string} message
     * @param {string} rule
     * @param {boolean} triggerInvalid
     * @returns {boolean} If the message was overwritten.
     */
    _overwriteMessageFromSameRule(field, message, rule, triggerInvalid = false) {
        field = $(field);
        let wasOverwritten = false;

        if (!field[0].validationMessage || this._currentMessageIsFromRule(field, rule)) {
            wasOverwritten = true;
            this._setMessage(field, message, rule, triggerInvalid);
        }

        return wasOverwritten;
    },

    /**
     * Set the validation message for the given field.
     *
     * @param {jQuery|*} field Anything jQuery accepts: https://api.jquery.com/jQuery/
     * @param {string} message
     * @param {string} rule
     * @param {boolean} triggerInvalid Trigger the invalid event after setting the message?
     */
    _setMessage(field, message, rule, triggerInvalid = false) {
        field = $(field);

        this._outputDebug('Setting validation message', [field.attr('name') || field.attr('id') || '', message]);

        field[0].setCustomValidity(message);
        this._setInvalidRule(field, rule);
        triggerInvalid && field[0].checkValidity();
    },

    /**
     * Was the current message set by the given tag?
     *
     * @param {jQuery|*} field Anything jQuery accepts: https://api.jquery.com/jQuery/
     * @param {string} tag
     * @returns {boolean}
     */
    currentMessageIsFromTag(field, tag) {
        return this._currentMessageIsFromRule(field, `externally_set_${tag}`);
    },

    /**
     * Was the current message set by the given rule?
     *
     * @param {jQuery|*} field Anything jQuery accepts: https://api.jquery.com/jQuery/
     * @param {string} rule
     * @returns {boolean}
     * @private
     */
    _currentMessageIsFromRule(field, rule) {
        const invalidRule = $(field).data('fieldValidate_invalid_rule');

        return invalidRule === rule || (rule === 'browser' && !invalidRule); // Assuming the rule was set by the browser if we don't have a note about which rule set the validation message.
    },

    /**
     * Set the currently invalid rule.
     * Convention for HTML rules is "browser".
     *
     * @param {jQuery|*} field Anything jQuery accepts: https://api.jquery.com/jQuery/
     * @param {string} rule
     * @private
     */
    _setInvalidRule(field, rule) {
        $(field).data('fieldValidate_invalid_rule', rule);
    },

    /**
     * Reset validation: remove ornaments, messages, etc.
     *
     * @param {jQuery|*} set Anything jQuery accepts: https://api.jquery.com/jQuery/
     * @returns {jQuery} The affected set.
     */
    resetValidation(set) {
        const _this = this;
        return this.removeOrnaments(set).each(function () {
            _this._outputDebug('Clearing validation message', [$(this).attr('name') || $(this).attr('id') || '', this.validationMessage]);
            this.setCustomValidity('');
            _this._setInvalidRule(this, '');
        });
    },

    /**
     * Remove validation ornaments.
     *
     * @param {jQuery|*} set Anything jQuery accepts: https://api.jquery.com/jQuery/
     * @returns {jQuery} The affected set.
     */
    removeOrnaments(set) {
        const _this = this;
        if ($(set).length === 1 && !$(set).is(':input')) {
            // We treat containers the same way we treat a listing of fields.
            set = $(set).find(':input:visible:not(:disabled)');
        }

        return $(set).removeClass('invalid').each(function () {
            _this._outputDebug('Removing validation ornaments', [$(this).attr('name') || $(this).attr('id') || '']);
            _this._toggleMessageOrnament(this, false);
        });
    },

    /**
     * Apply validation ornaments.
     *
     * @param {jQuery|*} set Anything jQuery accepts: https://api.jquery.com/jQuery/
     * @returns {jQuery} The affected set.
     */
    applyOrnaments(set) {
        const _this = this;
        if ($(set).length === 1 && !$(set).is(':input')) {
            // We treat containers the same way we treat a listing of fields.
            set = $(set).find(':input:visible:not(:disabled)');
        }

        this.removeOrnaments(set);

        return $(set).addClass('invalid').each(function () {
            _this._outputDebug('Applying validation ornaments', [$(this).attr('name') || $(this).attr('id') || '']);
            _this._toggleMessageOrnament(this, true);
        });
    },

    /**
     * Show or hide the validation message ornament for the given field.
     *
     * @param {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement|HTMLButtonElement} field An input field.
     * @param {boolean} isOn
     * @private
     */
    _toggleMessageOrnament(field, isOn) {
        let $previous = $(field);
        var message = String($previous[0].validationMessage);
        var errorClass = 'text-danger errorMsg pr-3';
        var prependError = false;

        // Dont group the dscsa_statuses checkboxes during validation
        if ($previous.parent().parent().is('.checkbox') && ($previous.attr('name') !== undefined && $previous.attr('name').indexOf('dscsa_statuses') == 0)) {
            $previous = $previous.parent();

        } else if ($previous.parent().parent().is('.checkbox') || $previous.parent().parent().is('.radio')) {
            // We're working with a stylized checkbox or radio button
            if ($previous.attr('name') !== undefined && $previous.attr('name').indexOf('[]') > -1) {
                // It's an array of checkboxes/radio buttons - update the message and move the ornament to the end of the list
                message = 'Please select at least one option if you want to proceed.';

                if ($previous.parent().parent().hasClass('errorOnFirst')) {
                    prependError = true;
                    $previous = $('input[name="' + $previous.attr('name') + '"]:first');
                } else {
                    $previous = $('input[name="' + $previous.attr('name') + '"]:last');
                }
                errorClass = errorClass + ' fancy-checkbox';
            }

            $previous = $previous.parent().parent();
        } else if ($previous.parent().is('.input-group')) {
            // We're working with one of these: https://getbootstrap.com/docs/4.5/components/input-group/
            $previous = $previous.parent();
        } else if ($previous.hasClass("select2-hidden-accessible") && $previous.data('select2') && $previous.data('select2').$container) {
            // We're working with one of these: https://select2.org/programmatic-control/methods#checking-if-the-plugin-is-initialized
            $previous = $previous.data('select2').$container;
        } else if ($previous.is(':radio') && $previous.parent().is('label') && $previous.parent().parent().is('.btn-group')) {
            // We're working with one of these: https://getbootstrap.com/docs/4.5/components/buttons/#checkbox-and-radio-buttons
            $previous = $previous.parent().parent();
        }

        if (isOn) {
            if (prependError) {
                $previous.before('<small class="' + errorClass + '">' + message.replace('\n', '<br>') + '</small>');
            } else {
                $previous.after('<small class="' + errorClass + '">' + message.replace('\n', '<br>') + '</small>');
            }
        } else {
            $previous.parent().find('.errorMsg').remove();
        }
    },

    /**
     * Gives you all of the sister fields that are invalid with this field for a given rule.
     *
     * @param {string} ruleName
     * @param {jQuery|* }field
     * @returns {string[]}
     * @private
     */
    _getInvalidSisterFields(ruleName, field) {
        return (field.data(`fieldValidate_invalid_sister_${ruleName}`) || '').split(',').filter(Boolean);
    },

    /**
     * Are all the sister fields valid for this field and the given rule? (in other words, do we not know of any invalid sister fields?)
     *
     * @param {string} ruleName
     * @param {jQuery|*} field
     * @returns {boolean}
     * @private
     */
    _allSisterFieldsValid(ruleName, field) {
        return this._getInvalidSisterFields(ruleName, field).length === 0;
    },

    /**
     * Is this field invalid because of the value in the given sister field?
     *
     * @param {string} ruleName
     * @param {jQuery|*} field
     * @param {jQuery|*} sisterField
     * @returns {boolean}
     * @private
     */
    _hasInvalidSisterField(ruleName, field, sisterField) {
        return this._getInvalidSisterFields(ruleName, field).includes(sisterField.attr('name'));
    },

    /**
     * Add a field as an invalid sister field for a given rule.
     *
     * @param {string} ruleName
     * @param {jQuery|*} field
     * @param {jQuery|*} sisterField
     * @private
     */
    _addInvalidSisterField(ruleName, field, sisterField) {
        const newSet = this._getInvalidSisterFields(ruleName, field);
        newSet.push(sisterField.attr('name'));

        field.data(`fieldValidate_invalid_sister_${ruleName}`, _.uniq(newSet).join(','));
    },

    /**
     * Mark the given field as a valid sister field, for the given rule.
     *
     * @param {string} ruleName
     * @param {jQuery|*} field
     * @param {jQuery|*} sisterField
     * @private
     */
    _removeInvalidSisterField(ruleName, field, sisterField) {
        const newSet = this._getInvalidSisterFields(ruleName, field)
            .filter(fieldName => fieldName !== sisterField.attr('name'));

        field.data(`fieldValidate_invalid_sister_${ruleName}`, newSet.join(','));
    },

    // Rules --------------------------------------------

    /**
     * When the mask plugin alters a field's value, it breaks the HTML minlength validation.
     * This is a band-aid for that.
     *
     * @param elem
     * @param initialRun
     */
    maskLength: function (elem, {initialRun = false} = {}) {
        if (!elem.data('mask')) {
            return;
        }

        const pluralizeCharacter = length => length + ' character' + (length === 1 ? '' : 's');
        const currentLength = elem.val().length;
        const expectedLength = String(elem.data('mask').mask || '').length;

        // maxlength should be taken care of by the browser by not allowing more characters to be entered.
        if (currentLength != 0 && currentLength < expectedLength) {
            this._overwriteMessageFromSameRule(
                elem,
                `Please lengthen this text to ${pluralizeCharacter(expectedLength)} or more (you are currently using ${pluralizeCharacter(currentLength)})`,
                'maskLength'
            );
        }
    },

    /**
     * Force the min length attribute
     *
     * @param elem
     * @param initialRun
     */
    minLength: function (elem, {initialRun = false} = {}) {
        // Make sure the element has a minlength attr, a value and is not currently hidden by fieldLib
        if (!elem.attr('minlength') || !elem.val() || elem.hasClass('set-name')) {
            return;
        }

        const pluralizeCharacter = length => length + ' character' + (length === 1 ? '' : 's');
        const currentLength = elem.val().length;
        const expectedLength = parseInt(elem.attr('minlength'));

        if (currentLength < expectedLength) {
            this._overwriteMessageFromSameRule(
                elem,
                `Please lengthen this text to ${pluralizeCharacter(expectedLength)} or more (you are currently using ${pluralizeCharacter(currentLength)})`,
                'minLength'
            );
        }
    },

    /**
     * Force the max length attribute
     *
     * @param elem
     * @param initialRun
     */
    maxLength: function (elem, {initialRun = false} = {}) {
        // Make sure the element has a maxlength attr, a value and is not currently hidden by fieldLib
        if (!elem.attr('maxlength') || !elem.val() || elem.hasClass('set-name')) {
            return;
        }

        const pluralizeCharacter = length => length + ' character' + (length === 1 ? '' : 's');
        const currentLength = elem.val().length;
        const expectedLength = parseInt(elem.attr('maxlength'));

        if (currentLength > expectedLength) {
            this._overwriteMessageFromSameRule(
                elem,
                `Please shorten this text to ${pluralizeCharacter(expectedLength)} or less (you are currently using ${pluralizeCharacter(currentLength)})`,
                'maxLength'
            );
        }
    },

    /**
     * Validate the element's value is a UPC
     * test: 123456787650
     *
     * @param {*} elem
     * @param settings
     */
    verifyUpcCheckDigit: function (elem, {initialRun = false} = {}) {
        var val = elem.val();

        if (!val.length) {
            return true;
        }

        var check_digit = val % 10;
        var upc = Math.floor(val / 10);

        console.log("upc->[" + upc + "] check_digit->[" + check_digit + "]");

        var factor = 3;
        var checksum = 0;
        var tmp = upc;

        while (tmp > 0) {
            var c = tmp % 10;
            tmp = Math.floor(tmp / 10);
            checksum += factor * c;

            if (factor == 3) {
                factor = 1;
            } else {
                factor = 3;
            }
        }

        checksum = checksum % 10;

        if (checksum != 0) {
            checksum = 10 - checksum;
        }

        console.log("checksum->[" + checksum + "]");

        if (checksum == check_digit) {
            return true;
        }

        this._overwriteMessageFromSameRule(elem, "The check digit is invalid", 'verifyUpcCheckDigit');
        return false;
    },

    validateVCFormat: function (elem, {initialRun = false} = {}) {
        var value = elem.val();

        // No value to check.
        if (!value) {
            return true;
        }

        // allow \w characters and: _ /
        if (/^[a-zA-Z0-9_\/ ]+$/i.test(value)) {
            return true;
        } else {
            this._overwriteMessageFromSameRule(elem, "No special characters allowed", 'validateVCFormat');
            return false;
        }
    },

    validateArticleIdentifier: function (elem, {initialRun = false} = {}) {
        if (initialRun) {
            return true;
        }

        let at_least_one = true;
        const _this = this;

        if ($("#category").val() != "7900") {
            // Hack to make the CS identifiers (and any other missing UOM identifiers) NOT REQUIRED when in maintenance
            // Only done if the set shipping method mathces the currently stored shipping method
            if ($("#shipping_method").hasClass('maintenance') && $("#shipping_method").val() == abcsetup.item.shipping_method){
                return true;
            }
            const css_classes = ["item_article_identifier", "inner_article_identifier", "case_article_identifier", "dozens_article_identifier", "display_article_identifier"];
            const err_msg = {
                "item_article_identifier": "Fill in at least one of EAN, GTIN, HIBC, HRI, NDC, UPC, VB or VC",
                "inner_article_identifier": "Fill in at least one of EAN, GTIN, HIBC, HRI, NDC, UPC, VB or VC if shipping method is Inners",
                "case_article_identifier": "Fill in at least one of EAN, GTIN, HIBC, HRI, NDC, UPC, VB or VC if shipping method is Cases",
                "dozens_article_identifier": "Fill in at least one of EAN, GTIN, HIBC, HRI, NDC, UPC or VB if shipping method is Dozens",
                "display_article_identifier": "Fill in at least one of EAN, GTIN, HIBC, HRI, NDC or UPC if shipping method is Display"
            };
            const ship_method = {
                "item_article_identifier": "EA",
                "inner_article_identifier": "PK",
                "case_article_identifier": "CS",
                "dozens_article_identifier": "DZ",
                "display_article_identifier": "DL",
            };

            const this_css_class = css_classes.find(css_class => elem.hasClass(css_class));
            const $articleIdentifierFields = $("." + this_css_class);

            if (this_css_class === 'item_article_identifier' || $("#shipping_method").val() === ship_method[this_css_class]) {
                // Always need to check item identifiers. For all others, whether we need to depends on which shipping method is selected.
                at_least_one = $articleIdentifierFields.toArray().some(elem => Boolean($(elem).val()));
            }

            if (at_least_one) {
                // Clear this rule's validation messages from fields in this validation group.
                $articleIdentifierFields.each(function () {
                    if (this.validationMessage === err_msg[this_css_class]) {
                        _this.resetValidation(this);
                    }
                });
            } else {
                // Apply this rule's validation message from fields in this validation group.
                $articleIdentifierFields.each(function () {
                    if (_this._currentMessageIsFromRule(this, 'browser')) {
                        _this._setMessage(this, err_msg[this_css_class], 'validateArticleIdentifier', true);
                    } else {
                        _this._overwriteMessageFromSameRule(this, err_msg[this_css_class], 'validateArticleIdentifier', true);
                    }
                });
            }
        }
        else {
            const css_classes = [
                "ssu_identifiers",
            ];
            const err_msg = {
                "ssu_identifiers": "Fill in at least one of the item, inners, dozens or case identifiers or the MFG Part Number",
            };

            const this_css_class = css_classes.find(css_class => elem.hasClass(css_class));
            const $articleIdentifierFields = $("." + this_css_class);

            at_least_one = $articleIdentifierFields.toArray().some(elem => Boolean($(elem).val()));

            if (at_least_one) {
                // Clear this rule's validation messages from fields in this validation group.
                $articleIdentifierFields.each(function () {
                    if (this.validationMessage === err_msg[this_css_class]) {
                        _this.resetValidation(this);
                    }
                });
            } else {
                // Apply this rule's validation message from fields in this validation group.
                $articleIdentifierFields.each(function () {
                    if (_this._currentMessageIsFromRule(this, 'browser')) {
                        _this._setMessage(this, err_msg[this_css_class], 'validateArticleIdentifier', true);
                    } else {
                        _this._overwriteMessageFromSameRule(this, err_msg[this_css_class], 'validateArticleIdentifier', true);
                    }
                });
            }
        }

        return at_least_one;
    },


    /**
     * Validate the element's value is a barcode
     *
     * @param {*} elem
     * @param initialRun
     */
    barCode: function (elem, {initialRun = false} = {}) {
        const value = elem.val();

        // Field is not required and no value is set
        if (!value) {
            return true;
        }

        const CCHAR = {
            "0": 0,
            "1": 1,
            "2": 2,
            "3": 3,
            "4": 4,
            "5": 5,
            "6": 6,
            "7": 7,
            "8": 8,
            "9": 9,
            "A": 10,
            "B": 11,
            "C": 12,
            "D": 13,
            "E": 14,
            "F": 15,
            "G": 16,
            "H": 17,
            "I": 18,
            "J": 19,
            "K": 20,
            "L": 21,
            "M": 22,
            "N": 23,
            "O": 24,
            "P": 25,
            "Q": 26,
            "R": 27,
            "S": 28,
            "T": 29,
            "U": 30,
            "V": 31,
            "W": 32,
            "X": 33,
            "Y": 34,
            "Z": 35,
            "-": 36,
            ".": 37,
            " ": 38,
            "$": 39,
            "/": 40,
            "+": 41,
            "%": 42,
        }

        const hibcc = value.toUpperCase();
        let checkDigit = 0;
        let checkChar;

        for (let i = 0; i < (hibcc.length - 1); i++) {
            checkDigit = checkDigit + CCHAR[hibcc[i]];
        }

        checkDigit = checkDigit % 43;
        console.log('checkDigit: ' + checkDigit);

        for (const key in CCHAR) {
            if (checkDigit == CCHAR[key]) {
                checkChar = key;
                break;
            }
        }

        if (checkChar == hibcc[hibcc.length - 1]) {
            return true;
        } else {
            this._outputDebug(`Expected end char: ${checkChar}`);
            this._overwriteMessageFromSameRule(elem, "The BarCode is invalid", 'barCode');
            return false;
        }
    },

    /**
     * Validate the element's value is a valid extended alpha numeric
     *
     * @param {*} elem
     * @param initialRun
     */
    alphaNumericExtended: function (elem, {initialRun = false} = {}) {
        var value = elem.val();

        if (value == '') {
            return true;
        }

        if (/^[a-zA-Z0-9#\$%&\*\(\)\-\_\+\=\.\:\/\"\<\>\' ]+$/i.test(value)) {
            return true;
        } else {
            this._overwriteMessageFromSameRule(elem, "No special characters allowed", 'alphaNumericExtended');
            return false;
        }
    },

    /**
     * Validate the HIBC value is a valid extended alpha numeric
     *
     * @param {*} elem
     * @param initialRun
     */
    alphaNumericHIBC: function (elem, {initialRun = false} = {}) {
        var value = elem.val();

        if (value == '') {
            return true;
        }

        if (/^[a-zA-Z0-9#\$%&\*\(\)\_\+\=\.\:\/\"\<\>\' ]+$/i.test(value)) {
            return true;
        } else {
            this._overwriteMessageFromSameRule(elem, "No special characters allowed", 'alphaNumericExtended');
            return false;
        }
    },

    alphaNumeric: function (elem, {initialRun = false} = {}) {
        var value = elem.val();

        if (value == '') {
            return true;
        }

        if (/^[a-zA-Z0-9\-\/ ]+$/i.test(value)) {
            return true;
        } else {
            this._overwriteMessageFromSameRule(elem, "No special characters allowed", 'alphaNumeric');
            return false;
        }
    },

    ZBFieldGreaterThanWac: function (elem, {initialRun = false} = {}) {
        var zb_val = parseFloat($(elem).val());
        var wac = parseFloat($("#invoice_cost").val());
        console.log("ZBFieldGreaterThanWac: zb->["+zb_val+"] wac->["+wac+"]");
        if((zb_val < wac) && $("#short_dated_prod").val() == 'Y') {
            this._overwriteMessageFromSameRule(elem, "Enter a value greater than the WAC", 'ZBFieldGreaterThanWac');
            return false ;
        }
        else {
            return true;
        }
    },

    numericOnly: function (elem, {initialRun = false} = {}) {
        var value = elem.val();

        if (value == '') {
            return true;
        }

        if (/^[0-9\/ ]+$/i.test(value)) {
            return true;
        } else {
            this._overwriteMessageFromSameRule(elem, "No special characters allowed", 'numericOnly');
            return false;
        }
    },

    /**
     * Validate the element's value is a valid sizeXquantity
     *
     * @param {*} elem
     * @param initialRun
     */
    sizeQuantity: function (elem, {initialRun = false} = {}) {
        var value = elem.val();

        // Field is not required and no value is set
        if (!elem.attr('required') && value == '') {
            return true;
        }

        //console.log("validateSizeQuantity: value->"+value);
        //value = value.replace(/\s+/g,'');
        //value = value.toLowerCase();
        //console.log("validateSizeQuantity: value->"+value);

        var res = value.split('X');

        if (!elem.attr('required') && value == '') {
            return true;
        }

        if (res[0] && (parseFloat(res[0]) > 999999 || parseFloat(res[0]) < 0.01)) {
            this._overwriteMessageFromSameRule(elem, "Enter a valid size quantity: either a single number, or two numbers between 0.01 and 999999 separated by an X, e.g. 2X3 (no spaces)", 'sizeQuantity');
            return false;
        }

        if (res[1] && (parseFloat(res[1]) > 999999 || parseFloat(res[1]) < 0.01)) {
            this._overwriteMessageFromSameRule(elem, "Enter a valid size quantity: either a single number, or two numbers between 0.01 and 999999 separated by an X, e.g. 2X3 (no spaces)", 'sizeQuantity');
            return false;
        }

        if (/^(((\d+|\d+\.\d{1,2}|\.\d{1,2})X(\d+|\d+\.\d{1,2}|\.\d{1,2})X(\d+|\d+\.\d{1,2}|\.\d{1,2}))X?|((\d+|\d+\.\d{1,2}|\.\d{1,2})X(\d+|\d+\.\d{1,2}|\.\d{1,2}))X?|(\d+|\d+\.\d{1,2}|\.\d{1,2}))$/.test(value)) {
            //if (/^\d{1,6}(\.\d{1,2})?(X\d{1,6}(\.\d{1,2})?){0,2}$/.test(value)) {
            return true;

        } else {
            this._overwriteMessageFromSameRule(elem, "Enter a valid size quantity: either a single number, or two numbers between 0.01 and 999999 separated by an X, e.g. 2X3 (no spaces)", 'sizeQuantity');
            return false;
        }
    },


    /**
     * Validate the element's value is a valid GTIN14
     *
     * @param {*} elem
     * @param initialRun
     */
    gtin14: function (elem, {initialRun = false} = {}) {
        var value = elem.val();

        // Field is not required and no value is set
        if (!elem.attr('required') && value == '') {
            return true;
        }

        var value_arr = value.split('');
        var target = value_arr[0];

        var numOccurences = $.grep(value_arr, function (elem) {
            return elem === target;
        }).length;

        if (numOccurences == 14) {
            this._overwriteMessageFromSameRule(elem, "Please enter a valid GTIN 14.", 'gtin14');
            return false;
        }

        if ($('#dscsa_exempt').val() == 'N') {
            if ($('#selling_unit_ndc10').length > 0) {
                var selling_unit_ndc10 = $('#selling_unit_ndc10');
                var ndc10 = selling_unit_ndc10.val().replace(/\-/g, '');
                console.log("checkGtin14: ndc10->" + ndc10);
                var gtin = value.substring(3, 13);
                console.log("checkGtin14: gtin->" + gtin);

                if (gtin != ndc10) {
                    elem[0].setCustomValidity("Please enter a valid GTIN 14.");
                    return false;
                }
            }
        }

        elem[0].setCustomValidity("");
        return true;
    },


    /**
     * Validate the element's value is greater than the specified field's value
     */
    greaterThan: function (elem, {initialRun = false} = {}) {
        if (!elem.data('greaterthan') && !elem.data('validate')) {
            console.error(`You must specify a field to validate against for greaterThan comparison (${elem.attr('name')})`);
            return true;
        }

        let isValid = true;
        for (const otherFieldName of (elem.data('greaterthan') || elem.data('validate') || '').split(',').filter(Boolean)) {
            // Find the target element if it doesn't have the .hid class (as a result of showIf)
            let targetElem = $('#' + otherFieldName).not('.showIfHide');
            if (!targetElem.length) {
                targetElem = $(':input[name="' + otherFieldName + '"]').not('.showIfHide');
            }

            if (!targetElem.length) {
                console.error(`Could not find other field for greaterThan comparison: ${otherFieldName} (${elem.attr('name')})`);
                return;
            }

            if (!elem.val() || !targetElem.val()) {
                continue;
            }

            if (parseFloat(elem.val()) <= parseFloat(targetElem.val())) {
                if (elem.attr("id") == 'item_weight' || elem.attr("id") == 'case_weight') {
                    if ($("#drop_ship_warehouse").val() == 'ZNSG') {
                        isValid = true;
                        break;
                    }
                }
                var name = $('label[for="' + targetElem.attr('id') + '"]').length ? $('label[for="' + targetElem.attr('id') + '"]').html() : targetElem.attr('name').replace(/_/g, ' ');
                const message = `Please specify a value greater than ${name} (${targetElem.val()})`;
                if (this._hasInvalidSisterField('greaterThan', elem, targetElem)) {
                    this._setMessage(elem, message, 'greaterThan');
                } else {
                    this._overwriteMessageFromSameRule(elem, message, 'greaterThan');
                }
                this._addInvalidSisterField('greaterThan', elem, targetElem);
                // It would be nice to add/update a less than message on the sister field here, but then this rule would be behaving like a lessThan rule and sort-of stepping on its toes.
                // I'm not sure what to think of that. But, it would be nice in the UI (especially not having a stale validation message ont he sister field).
                // this._addInvalidSisterField('lessThan', targetElem, elem);
                // this._overwriteMessageFromSameRule(targetElem, `Please specify a value less than ${elem.attr('name').replace(/_/g, ' ')} (${elem.val()})`, 'greaterThan');
                isValid = false;
                break;
            } else {
                this._removeInvalidSisterField('greaterThan', elem, targetElem);
                this._removeInvalidSisterField('greaterThan', targetElem, elem);

                if (this._allSisterFieldsValid('greaterThan', targetElem)) {
                    this.resetValidation(targetElem);
                }
            }
        }

        return isValid;
    },

    /**
     * Validate the element's value is greater than the specified field's value
     */
    greaterThanOrEqual: function (elem, {initialRun = false} = {}) {
        if (!elem.data('validate')) {
            console.error(`You must specify a field to validate against for greaterThanOrEqual comparison (${elem.attr('name')})`);
            return true;
        }

        let isValid = true;
        for (const otherFieldName of (elem.data('validate') || '').split(',').filter(Boolean)) {
            // Find the target element if it doesn't have the .hid class (as a result of showIf)
            let targetElem = $('#' + otherFieldName).not('.showIfHide');
            if (!targetElem.length) {
                targetElem = $(':input[name="' + otherFieldName + '"]').not('.showIfHide');
            }

            if (!targetElem.length) {
                console.error(`Could not find other field for greaterThanOrEqual comparison: ${otherFieldName} (${elem.attr('name')})`);
                return;
            }

            if (!elem.val() || !targetElem.val()) {
                continue;
            }

            if (parseFloat(elem.val()) < parseFloat(targetElem.val())) {
                var name = $('label[for="' + targetElem.attr('id') + '"]').length ? $('label[for="' + targetElem.attr('id') + '"]').html() : targetElem.attr('name').replace(/_/g, ' ');
                const message = `Please specify a value greater than or equal to ${name} (${targetElem.val()})`;
                if (this._hasInvalidSisterField('greaterThanOrEqual', elem, targetElem)) {
                    this._setMessage(elem, message, 'greaterThanOrEqual');
                } else {
                    this._overwriteMessageFromSameRule(elem, message, 'greaterThanOrEqual');
                }
                this._addInvalidSisterField('greaterThanOrEqual', elem, targetElem);
                isValid = false;
                break;
            } else {
                this._removeInvalidSisterField('greaterThanOrEqual', elem, targetElem);
                this._removeInvalidSisterField('greaterThanOrEqual', targetElem, elem);

                if (this._allSisterFieldsValid('greaterThanOrEqual', targetElem)) {
                    this.resetValidation(targetElem);
                }
            }
        }

        return isValid;
    },

    /**
     * Validate the element's value is smaller than or equal to the specified field's value
     */
     smallerThanOrEqual: function (elem, {initialRun = false} = {}) {
        if (!elem.data('validate')) {
            console.error(`You must specify a field to validate against for smallerThanOrEqual comparison (${elem.attr('name')})`);
            return true;
        }

        let isValid = true;
        for (const otherFieldName of (elem.data('validate') || '').split(',').filter(Boolean)) {
            // Find the target element if it doesn't have the .hid class (as a result of showIf)
            let targetElem = $('#' + otherFieldName).not('.showIfHide');
            if (!targetElem.length) {
                targetElem = $(':input[name="' + otherFieldName + '"]').not('.showIfHide');
            }

            if (!targetElem.length) {
                console.error(`Could not find other field for smallerThanOrEqual comparison: ${otherFieldName} (${elem.attr('name')})`);
                return;
            }

            if (!elem.val() || !targetElem.val()) {
                continue;
            }

            if (parseFloat(elem.val()) > parseFloat(targetElem.val())) {
                var name = $('label[for="' + targetElem.attr('id') + '"]').length ? $('label[for="' + targetElem.attr('id') + '"]').html() : targetElem.attr('name').replace(/_/g, ' ');
                const message = `Please specify a value smaller than or equal to ${name} (${targetElem.val()})`;
                if (this._hasInvalidSisterField('smallerThanOrEqual', elem, targetElem)) {
                    this._setMessage(elem, message, 'smallerThanOrEqual');
                } else {
                    this._overwriteMessageFromSameRule(elem, message, 'smallerThanOrEqual');
                }
                this._addInvalidSisterField('smallerThanOrEqual', elem, targetElem);
                isValid = false;
                break;
            } else {
                this._removeInvalidSisterField('smallerThanOrEqual', elem, targetElem);
                this._removeInvalidSisterField('smallerThanOrEqual', targetElem, elem);

                if (this._allSisterFieldsValid('smallerThanOrEqual', targetElem)) {
                    this.resetValidation(targetElem);
                }
            }
        }

        return isValid;
    },

    /**
     * Validate the pieces values with gtin grid qty values
     */
    validatePiecesQtyVal: function (elem, {initialRun = false} = {}) {
        var value = elem.val();
        console.log('validatePiecesQtyVal', elem);
        // Find the target element
        var targetElem = $('#' + elem.data('validate') + ':visible');
        if (!targetElem.length) {
            targetElem = $(':input[name="' + elem.data('validate') + '"]:visible');
        }

        var grid_field = elem.attr("name").match(/gtin_items\[(.*)\]\[(.*)\]/);
        var level_id;
        var level;
        if (grid_field) {
            if (grid_field[1] == "inner") {
                level = "pack";
            } else {
                level = grid_field[1];
            }
            if (!$("#" + level + "_pieces").is(":disabled")) {
                if (value != $("#" + level + "_pieces").val()) {
                    this._overwriteMessageFromSameRule(elem, "Please make sure the Qty fields in the GTIN Grid matches the Pieces fields on the Item & Packaging Information tab ", 'validatePiecesQtyVal');
                    return false;
                }
            }
            return true;
        }
        var pieces_field = elem.attr("name");
        if (pieces_field) {
            var level_id = pieces_field.split("_pieces");
            if (level_id[0] == "pack") {
                level = "inner";
            } else {
                level = level_id[0];
            }
            if ($("input[name='gtin_items[" + level + "][qty]']").length) {
                if (!$("input[name='gtin_items[" + level + "][qty]']").is(":disabled")) {
                    if (value != $("input[name='gtin_items[" + level + "][qty]']").val()) {
                        this._overwriteMessageFromSameRule(elem, "Please make sure the Qty fields in the GTIN Grid matches the Pieces fields on the Item & Packaging Information tab ", 'validatePiecesQtyVal');
                        return false;
                    }
                }
            }
            return true;
        }

        return true;
    },

    /**
     * Validate that the pieces values are multiples of each other
     */
    validatePiecesQtyMultiple: function (elem) {
        var value = elem.val();

        // Find the target element
        var targetElem = $('#' + elem.data('validate') + ':visible');
        if (!targetElem.length) {
            targetElem = $(':input[name="' + elem.data('validate') + '"]:visible');
        }

        var pieces_field = elem.attr('name');
        var item_pieces = parseFloat($("#item_pieces").val());
        var pack_pieces = parseFloat($("#pack_pieces").val());
        var case_pieces = parseFloat($("#case_pieces").val());
        var pallet_pieces = parseFloat($("#pallet_pieces").val());
        var pieces_check1;
        var pieces_check2;
        var isValid = true;

        if (pieces_field) {
            var level_id = pieces_field.split("_pieces");
            if (level_id[0] == "pack") {
                console.log('pack:' + pack_pieces + ' case:' + case_pieces);
                if (isNaN(pack_pieces) || isNaN(case_pieces)) {
                    isValid = true;
                } else {
                    pieces_check1 = Math.round((case_pieces / pack_pieces) * 100.0) / 100.0;
                    if (pieces_check1 % 1 == 0) {
                        isValid = true;
                    } else {
                        isValid = false;
                    }
                }

                if (isNaN(pack_pieces) || isNaN(item_pieces)) {
                    isValid = true;
                } else {
                    pieces_check2 = Math.round((pack_pieces / item_pieces) * 100.0) / 100.0;
                    if (Math.floor(pieces_check2) == pieces_check2) {
                        isValid = true;
                    } else {
                        isValid = false;
                    }
                }
            } else if (level_id[0] == "case") {
                if (isNaN(pack_pieces) || isNaN(case_pieces)) {
                    return true;
                } else {
                    pieces_check2 = Math.round((case_pieces / pack_pieces) * 100.0) / 100.0;

                    if (pieces_check2 % 1 == 0) {
                        isValid = true;
                    } else {
                        isValid = false;
                    }
                }
            }
        }

        if (isValid) {
            return true;
        } else {
            this._overwriteMessageFromSameRule(elem, "Please enter a valid number so that the Pieces fields are multiples of the item pack on the Item & Packaging Information tab", 'validatePiecesQtyMultiple');
            return false;
        }
    },

    /**
     * Validate zone pricing ends with a 9 and not .09
     *
     * @param {*} elem
     * @param initialRun
     */
    verifyPricing: function(elem, {initialRun = false} = {}) {
        var value = elem.val();

        if (((value % 0.1).toFixed(2) != 0.09) || ((value % 1).toFixed(2) == 0.09)) {
            this._overwriteMessageFromSameRule(elem, "All prices should end with a 9 and prices ending with .09 should be rounded to .19", 'verifyPricing');
            return false;
	    }

        return true;
	},

    /**
     *
     * @param {*} elem
     * @returns
     */
    checkLevelWeight: function (elem) {
        var value = elem.val();
        console.log("checkCaseWeight: value->" + value);

        var item_weight = parseFloat($("#item_weight").val());
        var case_weight = parseFloat($("#case_weight").val());
        var pack_weight = parseFloat($("#pack_weight").val());
        var pallet_weight = parseFloat($("#pallet_weight").val());
        var custom_message = "";

        if (elem.attr('name') == "item_weight") {
            if (isNaN(item_weight)) {
                elem[0].setCustomValidity("");
                return true;
            }
            if (isNaN(pack_weight)) {
                elem[0].setCustomValidity("");
                return true;
            }
            if (item_weight > pack_weight) {
                custom_message = "Item weight (" + item_weight + ") cannot be larger than pack weight (" + pack_weight + ")";
                elem[0].setCustomValidity(custom_message);
                return false;
            }
        } else if (elem.attr('name') == "pack_weight") {
            if (isNaN(item_weight)) {
                elem[0].setCustomValidity("");
                return true;
            }
            if (isNaN(pack_weight)) {
                elem[0].setCustomValidity("");
                return true;
            }
            if (item_weight > pack_weight) {
                custom_message = "Item weight (" + item_weight + ") cannot be larger than pack weight (" + pack_weight + ")";
                elem[0].setCustomValidity(custom_message);
                return false;
            }
            if (isNaN(case_weight)) {
                elem[0].setCustomValidity("");
                return true;
            }
            if (pack_weight > case_weight) {
                custom_message = "Pack weight (" + pack_weight + ") cannot be larger than case weight (" + case_weight + ")";
                elem[0].setCustomValidity(custom_message);
                return false;
            }
        } else if (elem.attr('name') == "case_weight") {
            if (isNaN(pack_weight)) {
                elem[0].setCustomValidity("");
                return true;
            }
            if (isNaN(case_weight)) {
                elem[0].setCustomValidity("");
                return true;
            }
            if (pack_weight > case_weight) {
                custom_message = "Pack weight (" + pack_weight + ") cannot be larger than case weight (" + case_weight + ")";
                elem[0].setCustomValidity(custom_message);
                return false;
            }
            if (isNaN(pallet_weight)) {
                elem[0].setCustomValidity("");
                return true;
            }
            if (case_weight >= pallet_weight) {
                custom_message = "Case weight (" + case_weight + ") cannot be larger than pallet weight (" + pallet_weight + ")";
                elem[0].setCustomValidity(custom_message);
                return false;
            }
        } else if (elem.attr('name') == "pallet_weight") {
            if (isNaN(case_weight)) {
                elem[0].setCustomValidity("");
                return true;
            }
            if (isNaN(pallet_weight)) {
                elem[0].setCustomValidity("");
                return true;
            }
            if (case_weight >= pallet_weight) {
                custom_message = "Case weight (" + case_weight + ") cannot be larger than pallet weight (" + pallet_weight + ")";
                elem[0].setCustomValidity(custom_message);
                return false;
            }
        }

    },
    checkUrlOrEmail: function (elem) {
        var value = elem.val();
        if (value == "") {
            return true;
        }
        // Find the target element
        var targetElem = $('#' + elem.data('validate') + ':visible');
        if (!targetElem.length) {
            targetElem = $(':input[name="' + elem.data('validate') + '"]:visible');
        }

        var isValid = true;
        if (value.substr(0, 7) != 'http://' && value.substr(0, 8) !== "https://" && value.substr(0, 6) !== "ftp://") {
            if (/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(value)) {
                elem[0].setCustomValidity("");
                isValid = true;
            } else {
                value = 'http://' + value;

                if (value.substr(value.length - 1, 1) != '/') {
                    value = value + '/';
                }
            }
        }
        isValid = /^(http|https|ftp):\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i.test(value);

        if (isValid) {
            elem[0].setCustomValidity("");
            return true;
        } else {
            elem[0].setCustomValidity("Not a valid url");
            return false;
        }
    },

    /**
     * Validate the element's value has no special characters
     */
    alphanumericextended: function (elem) {
        var value = elem.val();
        var isValid = true;

        // Find the target element
        var targetElem = $('#' + elem.data('validate') + ':visible');
        if (!targetElem.length) {
            targetElem = $(':input[name="' + elem.data('validate') + '"]:visible');
        }

        if (value != "") {
            // allow \w characters and: # $ % & * () - _ + = . : / " <> '
            isValid = /^[a-zA-Z0-9#\$%\^&\*\(\)\-\_\+\=\.\:\/\"\<\>\' ]+$/i.test(value);
        }

        if (isValid) {
            elem[0].setCustomValidity("");
            return true;
        } else {
            elem[0].setCustomValidity("No special characters allowed");
            return false;
        }
    },


    /**
     * Validate the element's value has only letters
     */
    lettersonly: function (elem) {
        var value = elem.val();
        var isValid = true;

        // Find the target element
        var targetElem = $('#' + elem.data('validate') + ':visible');
        if (!targetElem.length) {
            targetElem = $(':input[name="' + elem.data('validate') + '"]:visible');
        }

        if (value != "") {
            // modify the method provided by additional-methods to allow white spaces
            isValid = /^[a-z ]+$/i.test(value);
        }

        if (isValid) {
            elem[0].setCustomValidity("");
            return true;
        } else {
            elem[0].setCustomValidity("Letters and spaces only please");
            return false;
        }
    },

    /**
     * Validate the element's value is less than the specified field's value
     */
    lessThan: function (elem, {initialRun = false} = {}) {
        if (!elem.data('lessthan') && !elem.data('validate')) {
            console.error(`You must specify a field to validate against for lessThan comparison (${elem.attr('name')})`);
            return true;
        }

        let isValid = true;
        for (const otherFieldName of (elem.data('lessthan') || elem.data('validate') || '').split(',').filter(Boolean)) {
            // Find the target element if it doesn't have the .hid class (as a result of showIf)
            let targetElem = $('#' + otherFieldName).not('.showIfHide');
            if (!targetElem.length) {
                targetElem = $(':input[name="' + otherFieldName + '"]').not('.showIfHide');
            }

            if (!targetElem.length) {
                console.error(`Could not find other field for lessThan comparison: ${otherFieldName} (${elem.attr('name')})`);
                return;
            }

            if (!elem.val() || !targetElem.val()) {
                continue;
            }

            if (parseFloat(elem.val()) >= parseFloat(targetElem.val())) {
                if (elem.attr("id") == 'item_weight' || elem.attr("id") == 'case_weight') {
                    if ($("#drop_ship_warehouse").val() == 'ZNSG') {
                        isValid = true;
                        break;
                    }
                }
                const message = `Please specify a value less than ${targetElem.attr('name').replace(/_/g, ' ')} (${targetElem.val()})`;
                if (this._hasInvalidSisterField('greaterThan', elem, targetElem)) {
                    this._setMessage(elem, message, 'greaterThan');
                } else {
                    this._overwriteMessageFromSameRule(elem, message, 'lessThan');
                }
                this._addInvalidSisterField('lessThan', elem, targetElem);
                // It would be nice to add/update a greater than message on the sister field here, but then this rule would be behaving like a greater rule and sort-of stepping on its toes.
                // I'm not sure what to think of that. But, it would be nice in the UI (especially not having a stale validation message ont he sister field).
                // this._overwriteMessageFromSameRule(targetElem, `Please specify a value greater than ${elem.attr('name').replace(/_/g, ' ')} (${elem.val()})`, 'lessThan');
                // this._addInvalidSisterField('greaterThan', targetElem, elem);
                isValid = false;
                break;
            } else {
                this._removeInvalidSisterField('lessThan', elem, targetElem);
                this._removeInvalidSisterField('lessThan', targetElem, elem);

                if (this._allSisterFieldsValid('lessThan', targetElem)) {
                    this.resetValidation(targetElem);
                }
            }
        }

        return isValid;
    },

    /**
     * Validate the element's value is less than (or equal to) the specified field's value
     */
    lessThanOrEqual: function (elem, {initialRun = false} = {}) {
        if (!elem.data('validate')) {
            console.error(`You must specify a field to validate against for lessThanOrEqual comparison (${elem.attr('name')})`);
            return true;
        }

        let isValid = true;
        for (const otherFieldName of (elem.data('validate') || '').split(',').filter(Boolean)) {
            // Find the target element if it doesn't have the .hid class (as a result of showIf)
            let targetElem = $('#' + otherFieldName).not('.showIfHide');
            if (!targetElem.length) {
                targetElem = $(':input[name="' + otherFieldName + '"]').not('.showIfHide');
            }

            if (!targetElem.length) {
                console.error(`Could not find other field for lessThanOrEqual comparison: ${otherFieldName} (${elem.attr('name')})`);
                return;
            }

            if (!elem.val() || !targetElem.val()) {
                continue;
            }

            if (parseFloat(elem.val()) > parseFloat(targetElem.val())) {
                var name = $('label[for="' + targetElem.attr('id') + '"]').length ? $('label[for="' + targetElem.attr('id') + '"]').html() : targetElem.attr('name').replace(/_/g, ' ');
                const message = `Please specify a value less than or equal to ${name} (${targetElem.val()})`;
                if (this._hasInvalidSisterField('lessThanOrEqual', elem, targetElem)) {
                    this._setMessage(elem, message, 'lessThanOrEqual');
                } else {
                    this._overwriteMessageFromSameRule(elem, message, 'lessThanOrEqual');
                }
                this._addInvalidSisterField('lessThanOrEqual', elem, targetElem);
                isValid = false;
                break;
            } else {
                this._removeInvalidSisterField('lessThanOrEqual', elem, targetElem);
                this._removeInvalidSisterField('lessThanOrEqual', targetElem, elem);

                if (this._allSisterFieldsValid('lessThanOrEqual', targetElem)) {
                    this.resetValidation(targetElem);
                }
            }
        }

        return isValid;
    },

    /**
     *
     * @param {*} elem
     */
    /*
    saleable: function(elem, {initialRun = false} = {}) {
        var value = elem.val();

        $('.gtin_saleable_unit').each(function () {
            if ($(this).val() == 'Y') {
                return false;
            }
        });

        this._overwriteMessageFromSameRule(elem, "Select at least one level as a saleable unit", 'saleable');
        return false;
    },
    */


    /**
     *
     * @param {*} elem
     */
    /*
    piecesQtyVal: function(elem, {initialRun = false} = {}) {
        var value = elem.val();

        if (!elem.attr('required') && value == '') {
            return true;
        }

        var grid_field = element.name.match(/gtin_items\[(.*)\]\[(.*)\]/);
        var level_id;
        var level;

        if (grid_field) {
            if (grid_field[1] == "inner") {
                level = "pack";
            } else {
                level = grid_field[2];
            }

            if (!$("input[name='rx_item["+level+"_pieces]']").is(":disabled")) {
                if (value != $("input[name='rx_item["+level+"_pieces]']").val()) {
                    return false;
                }
            }

            return true;
        }

        var pieces_field = element.name.match(/rx_item\[(.*)\]/);
        if (pieces_field) {
            var level_id = pieces_field[1].split("_pieces");
            if (level_id[0] == "pack") {
                level = "inner";
            }
            else {
                level = level_id[0];
            }
            if (!$("input[name='rx_item[gtin_items]["+level+"][qty]']").is(":disabled")) {
                if (value != $("input[name='rx_item[gtin_items]["+level+"][qty]']").val()) {
                    return false;
                }
            }
            return true;
        }

        return true;
//}, "Please make sure the Qty fields in the GTIN Grid matches the Pieces fields on the Item & Packaging Information tab.");
    },
    */


    /**
     * Validate the element's value is not a duplicate rx item
     *
     * @param elem
     * @param initialRun
     * @returns {boolean|Promise<void>}
     */
    rxDuplicateCheck: function (elem, {initialRun = false} = {}) {
        var value = elem.val();

        if (value == '') {
            elem.data('rxDuplicateCheck_checked', null);
            elem.parent().find('.duplicates').remove();
            return true;
        }

        // We've already dup-checked current value
        if (elem.data('rxDuplicateCheck_checked') == value || value == '') {
            return true;
        }

        //if (!abcsetup.item) {
        //    abcsetup.alerts.show('_jquery.fieldValidate.js Error', 'Please define <b>abcsetup.item</b> before using rxDuplicateCheck');
        //}

        elem.data('rxDuplicateCheck_checked', value);
        elem.parent().find('.duplicates').remove();

        return axios.post('/api/rx_item/search', {column: elem.attr('id'), value: value}).then(response => {
            elem.parent().append(`
                <div class="duplicates hide alert alert-rillc alert-rillc-attention">
                    <h3 class="theme-color">
                        <i class="fas fa-circle-exclamation fa-beat" style="--fa-animation-duration: 0.5s;--fa-animation-iteration-count: 5;"></i> Attention
                    </h3>
                    <p>Duplicate items have been found (<b>` + value + `</b>):<ul></ul></p>
                </div>
            `);

            $(response.data).each(function () {
                if (abcsetup.item !== undefined) {
                    if (this.id != abcsetup.item.id) {
                        var html = '<li>Item <b>' + this.supplier_descr + '</b> exists ';
                        if (this.workflow) {
                            html = html + 'in workflow <b>' + this.workflow + '</b> ';
                        }
                        html = html + 'with status <b>' + this.item_status_name + '</b></li>';

                        elem.parent().find('.duplicates ul').append('<li>Item <b>' + this.name + '</b> exists in workflow <b>' + this.workflow + '</b> with status <b>' + this.item_status_name + '</b></li>');
                        elem.parent().find('.duplicates').show();
                    }
                } else {
                    var html = '<li>Item <b>' + this.supplier_descr + '</b> exists ';
                    if (this.workflow) {
                        html = html + 'in workflow <b>' + this.workflow + '</b> ';
                    }
                    html = html + 'with status <b>' + this.item_status_name + '</b></li>';

                    elem.parent().find('.duplicates ul').append('<li>Item <b>' + this.name + '</b> exists in workflow <b>' + this.workflow + '</b> with status <b>' + this.item_status_name + '</b></li>');
                    elem.parent().find('.duplicates').show();
                }
            });
        });
    },


    /**
     * Validate the element's value is not a duplicate front store item
     *
     * @param elem
     * @param initialRun
     * @returns {boolean|Promise<void>}
     */
    frontStoreDuplicateCheck: function (elem, {initialRun = false} = {}) {
        var value = elem.val();

        if (value == '') {
            elem.data('frontStoreDuplicateCheck_checked', null);
            elem.parent().find('.duplicates').remove();
            return true;
        }

        // We've already dup-checked current value
        if (elem.data('frontStoreDuplicateCheck_checked') == value || value == '') {
            return true;
        }

        if (abcsetup.item) {
            console.log(`Front store item duplicate check ignoring ID ${abcsetup.item.id} (edit mode).`);
        } else {
            console.log('Front store item duplicate check not ignoring any discovered items (create mode).');
        }

        elem.data('frontStoreDuplicateCheck_checked', value);
        elem.parent().find('.duplicates').remove();

        return axios.post('/api/front_store/search', {column: elem.attr('id'), value: value}).then(response => {
            elem.parent().append('<div class="duplicates hide alert alert-warning"><i class="fas fa-exclamation-circle"></i> Duplicate items have been found (<b>' + value + '</b>):<ul></ul></div>');

            $(response.data).each(function () {
                if (!abcsetup.item || this.id != abcsetup.item.id) {
                    var html = '<li>Item <b>' + this.supplier_descr + '</b> exists ';
                    if (this.workflow) {
                        html = html + 'in workflow <b>' + this.workflow + '</b> ';
                    }
                    html = html + 'with status <b>' + this.item_status_name + '</b></li>';

                    elem.parent().find('.duplicates ul').append(html);
                    elem.parent().find('.duplicates').show();
                }
            });
        });
    },


    /**
     * Validate the element's value is a valid SAP number, looking at ALL valid SAP numbers.
     *
     * @param elem
     * @param initialRun
     * @returns {boolean|Promise<boolean>}
     */
    anySapNum: function (elem, {initialRun = false} = {}) {
        const value = String(elem.val());

        if (!value) {
            fieldValidate.removeOrnaments(elem);
            elem.data('anySapNum_checked', null);
            return true;
        }

        // No value, value isn't valid, or we've already the current value
        if (!value || value.length !== 8 || elem.data('anySapNum_checked') === value) {
            return true;
        }

        elem.data('sap-num-checked', value);
        fieldValidate.removeOrnaments(elem);

        return axios.get('/api/abc_item/check_exists', {
            params: {
                column: 'sap_num',
                identifier: value,
                all: true
            }
        }).then(response => {
            if (!response.data.exists) {
                this._overwriteMessageFromSameRule(elem, "Could not find record of this item.", 'anySapNum');
            }

            return response.data.exists;
        });
    },


    /**
     * Validate the element's value is not a duplicate front store item
     */
    attachmentFile: function (elem, {initialRun = false} = {}) {
        var value = elem.val();

        // Field is not required and no value is set
        if (!elem.attr('required') && value == '') {
            return true;
        }

        if (!parseInt(value)) {
            this._overwriteMessageFromSameRule(elem, "Please specify a " + elem.data('type'), 'attachmentFile');
            return false;
        }

        return true;
    },

    /**
     * Enforce two dates to be in a given sequence.
     *
     * You must add these data to your field for this rule:
     *   - datecomparison_otherfield: a selector for the field we're comparing tis field against.
     *   - datecomparison_type: the type of comparison we are doing: 'before', 'after', ...
     *
     * @param elem
     * @param initialRun
     */
    dateComparison(elem, {initialRun = false} = {}) {
        const otherField = $(elem.data('datecomparison_otherfield'));
        const comparisonType = elem.data('datecomparison_type');
        const beforeField = $(elem.data('datecomparison_beforefield'));
        const afterField = $(elem.data('datecomparison_afterfield'));

        if (comparisonType === 'between') {
            const setValidationMessages = (message) => {
                this._overwriteMessageFromSameRule(elem, message, 'dateComparison');

                this._addInvalidSisterField('dateComparison', elem, beforeField);
                this._addInvalidSisterField('dateComparison', elem, afterField);
                this._addInvalidSisterField('dateComparison', beforeField, elem);
                this._addInvalidSisterField('dateComparison', afterField, elem);
            };

            // If this one is valid, the other one is valid as well. We also don't want to stomp on other validation messages that might be on that field.
            const resetValidation = () => {
                this._removeInvalidSisterField('dateComparison', elem, beforeField);
                this._removeInvalidSisterField('dateComparison', elem, afterField);
                this._removeInvalidSisterField('dateComparison', beforeField, elem);
                this._removeInvalidSisterField('dateComparison', afterField, elem);

                if (this._allSisterFieldsValid('dateComparison', beforeField)) {
                    this.resetValidation(beforeField);
                }
                if (this._allSisterFieldsValid('dateComparison', afterField)) {
                    this.resetValidation(afterField);
                }
            };
            if (!beforeField.length) {
                console.error(`Could not find before field for date comparison: ${elem.data('datecomparison_beforefield')} (${elem.attr('name')})`);
                return;
            } else if (!elem.val() || !beforeField.val()) {
                return true;
            }
            if (!afterField.length) {
                console.error(`Could not find before field for date comparison: ${elem.data('datecomparison_afterfield')} (${elem.attr('name')})`);
                return;
            } else if (!elem.val() || !afterField.val()) {
                return true;
            }
            var beforeFieldText = beforeField.attr('name').replace(/_/g, ' ');
            if ($('label[for="'+beforeField.attr('name')+'"]').length){
                beforeFieldText = $('label[for="'+beforeField.attr('name')+'"]').html().replace(/_/g, ' ');
            }
            var afterFieldText = afterField.attr('name').replace(/_/g, ' ');
            if ($('label[for="'+afterField.attr('name')+'"]').length){
                afterFieldText = $('label[for="'+afterField.attr('name')+'"]').html().replace(/_/g, ' ');
            }

            if (!moment(elem.val()).isSameOrBefore(beforeField.val()) || !moment(elem.val()).isSameOrAfter(afterField.val())) {
                setValidationMessages(`Must be between ${beforeFieldText} and ${afterFieldText}`)
                return false;
            }

            resetValidation();
            return true;
        }

        if (!otherField.length) {
            console.error(`Could not find other field for date comparison: ${elem.data('datecomparison_otherfield')} (${elem.attr('name')})`);
            return;
        } else if (!elem.val() || !otherField.val()) {
            return true;
        }

        // Use the fields name in the error message
        // If the field has a label, use its value instead.

        // const elemFieldText = elem.attr('name').replace(/_/g, ' ')
        var elemFieldText = elem.attr('name').replace(/_/g, ' ');
        if (typeof(elem.attr('data-label')) !== 'undefined'){
            elemFieldText = elem.attr('data-label');
        }
        if ($('label[for="'+elem.attr('name')+'"]').length){
            elemFieldText = $('label[for="'+elem.attr('name')+'"]').html().replace(/_/g, ' ');
        }
        // const otherFieldText = otherField.attr('name').replace(/_/g, ' ');
        var otherFieldText = otherField.attr('name').replace(/_/g, ' ');
        if (typeof(otherField.attr('data-label')) !== 'undefined'){
            otherFieldText = otherField.attr('data-label');
        }

        if ($('label[for="'+otherField.attr('name')+'"]').length){
            otherFieldText = $('label[for="'+otherField.attr('name')+'"]').html().replace(/_/g, ' ');
        }

        const setValidationMessages = (message, otherMessage) => {
            this._overwriteMessageFromSameRule(elem, message, 'dateComparison');
            this._overwriteMessageFromSameRule(otherField, otherMessage, 'dateComparison', true);

            this._addInvalidSisterField('dateComparison', elem, otherField);
            this._addInvalidSisterField('dateComparison', otherField, elem);
        };

        // If this one is valid, the other one is valid as well. We also don't want to stomp on other validation messages that might be on that field.
        const resetValidation = () => {
            this._removeInvalidSisterField('dateComparison', elem, otherField);
            this._removeInvalidSisterField('dateComparison', otherField, elem);

            if (this._allSisterFieldsValid('dateComparison', otherField)) {
                this.resetValidation(otherField);
            }
        };

        if (comparisonType === 'before') {
            if (!moment(elem.val()).isBefore(otherField.val())) {
                setValidationMessages(`Must be before ${otherFieldText}`, `Must be after ${elemFieldText}`)
                return false;
            }

            resetValidation();
            return true;
        }

        if (comparisonType === 'after') {
            if (!moment(elem.val()).isAfter(otherField.val())) {
                setValidationMessages(`Must be after ${otherFieldText}`, `Must be before ${elemFieldText}`)
                return false;
            }

            resetValidation();
            return true;
        }

        if (comparisonType === 'afterOrSame') {
            if (!moment(elem.val()).isSameOrAfter(otherField.val())) {
                setValidationMessages(`Must be after or same as ${otherFieldText}`, `Must be before or same as ${elemFieldText}`)
                return false;
            }

            resetValidation();
            return true;
        }

        if (comparisonType === 'beforeOrSame') {
            if (!moment(elem.val()).isSameOrBefore(otherField.val())) {
                setValidationMessages(`Must be before or same as ${otherFieldText}`, `Must be after or same as ${otherFieldText}`)
                return false;
            }

            resetValidation();
            return true;
        }

        console.error(`Unknown dateComparison validation type: ${comparisonType} (${elem.attr('name')})`);
    },

    checkSapDiv: function (elem) {
        var unique_materials_division = $("#unique_materials_division").val();
        var count = 0;
        $('input.enable_sap_division:checkbox:checked').each(function () {
            count++;
        });

        if (unique_materials_division == 'N' && (count > 1 || count == 0)) {
            const message = "If `Are unique materials required for each division?` is set to `N`, please select only 1 SAP division, if set to `Y` please select more than 1 SAP division.";
            this._overwriteMessageFromSameRule(elem, message, 'checkSapDiv');
            return false;
        } else if (unique_materials_division == 'Y' && (count >= 0 && count <= 1)) {
            const message = "If `Are unique materials required for each division?` is set to `N`, please select only 1 SAP division, if set to `Y` please select more than 1 SAP division.";
            this._overwriteMessageFromSameRule(elem, message, 'checkSapDiv');
            return false;
        }

        elem[0].setCustomValidity("");
        return true;
    },

    /**
     * Set a limit to the number of _words_ that can be in a text field.
     *
     * @param elem
     * @param initialRun
     */
    maxWords: function (elem, {initialRun = false} = {}) {
        // Make sure the element has a maxWords entry, a value and is not currently hidden by fieldLib
        if (!elem.data('maxWords') || !elem.val() || elem.hasClass('set-name')) {
            return;
        }

        const pluralizeWord = length => length + ' word' + (length === 1 ? '' : 's');
        const currentLength = String(elem.val()).trim().split(/\s+/).length;
        const expectedLength = parseInt(elem.data('maxWords'), 10);

        if (currentLength > expectedLength) {
            this._overwriteMessageFromSameRule(
                elem,
                `Please shorten this to ${pluralizeWord(expectedLength)} or less (you are currently using ${pluralizeWord(currentLength)})`,
                'maxWords'
            );
        }
    },

    promoPlanOpportunity : function (elem, {initialRun = false} = {}) {
        if (initialRun) {
            return true;
        }

        // Require at least one Category
        // All selected categories should add up to no more than 100%
        const _this = this;
        const this_css_class = elem.data('group-class');

        const err_msg = "Please select at least one opportunity";
        const $categoryFields = $("." + this_css_class);

        let at_least_one = true;
        at_least_one = $categoryFields.toArray().some(elem => Boolean($(elem).val()));

        if (at_least_one) {
            // Clear this rule's validation messages from fields in this validation group.
            $categoryFields.each(function () {
                if (this.validationMessage === err_msg) {
                    _this.resetValidation(this);
                }
            });
        } else {
            // Apply this rule's validation message from fields in this validation group.
            $categoryFields.each(function () {
                if (_this._currentMessageIsFromRule(this, 'browser')) {
                    _this._setMessage(this, err_msg, 'promoPlanOpportunity', true);
                } else {
                    _this._overwriteMessageFromSameRule(this, err_msg, 'promoPlanOpportunity', true);
                }
            });
        }

        return at_least_one;
    },
    promoPlanCategory : function (elem, {initialRun = false} = {}) {
        if (initialRun) {
            return true;
        }

        // Require at least one Category
        // All selected categories should add up to no more than 100%
        const _this = this;
        const this_css_class = elem.data('group-class');
        const perc_unallocated = elem.closest('.promo_category_select_container').find('.perc_unallocated');

        const err_msg = "Please select at least one category";
        const err_msg_perc = "Total category percentage spend is larger than 100%";
        const $categoryFields = $("." + this_css_class);

        let sum = 0;
        let at_least_one = true;
        at_least_one = $categoryFields.toArray().some(elem => Boolean($(elem).val()));

        if (at_least_one) {
            // Clear this rule's validation messages from fields in this validation group.
            $categoryFields.each(function () {
                if (this.validationMessage === err_msg) {
                    _this.resetValidation(this);
                }
            });
        } else {
            // Apply this rule's validation message from fields in this validation group.
            $categoryFields.each(function () {
                if (_this._currentMessageIsFromRule(this, 'browser')) {
                    _this._setMessage(this, err_msg, 'promoPlanCategory', true);
                } else {
                    _this._overwriteMessageFromSameRule(this, err_msg, 'promoPlanCategory', true);
                }
            });
        }
        $categoryFields.each(function () {
            if (this.value)
                sum += parseFloat(this.value);

            if (sum > 100){
                if (_this._currentMessageIsFromRule(this, 'browser')) {
                    _this._setMessage(this, err_msg_perc, 'promoPlanCategory', true);
                    return false;
                } else {
                    _this._overwriteMessageFromSameRule(this, err_msg_perc, 'promoPlanCategory', true);
                }
            } else {
                if (this.validationMessage === err_msg_perc) {
                    _this.resetValidation(this);
                }
            }
        });

        return at_least_one && (sum < 100);
    },

    /**
     * Validate if currency with decimal
     *
     * @param elem
     * @param initialRun
     */
    currency: function (elem, {initialRun = false} = {}) {
        var regex  = /^\d+(?:\.\d{0,2})$/;
        const _this = this;

        if (initialRun || regex.test(elem.val())) {
            return true;
        }

        this._setMessage(elem, 'Invalid price format. Ex: XX.XX', 'currency', true);
        return false;
    },
}
